import styled from 'styled-components'

const SidebarContainerUi = styled.div`
  overflow-y: auto;
  height: calc(100% - 50px); /* compensate fixed sidebar title + footer */
`

export default SidebarContainerUi
